import { render, staticRenderFns } from "./OrgStockMoneyChange.vue?vue&type=template&id=253ca70f&scoped=true&"
import script from "./OrgStockMoneyChange.vue?vue&type=script&lang=js&"
export * from "./OrgStockMoneyChange.vue?vue&type=script&lang=js&"
import style0 from "./OrgStockMoneyChange.vue?vue&type=style&index=0&id=253ca70f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ca70f",
  null
  
)

export default component.exports